export const fr = {
  activityPage: {
    spotlight: " - Bénévoles à l'honneur",
    view_all_events: 'Voir toutes les activités',
    empty_events_title: "Pas encore d'activités",
    empty_events_desc:
      "Il semble qu'il n'y ait pas d'activités bénévoles à venir dans votre entreprise. Demandez une activité ou créez la vôtre pour y participer avec votre équipe !",
    request_button: 'Demander une activité',
    morning: 'Bonjour',
    afternoon: 'Bon après-midi',
    evening: 'Bonsoir',
    hi: 'Salut',
    greeting_desc: 'Faisons du bénévolat avec ',
    greeting_desc_greenshield:
      'Motivés par notre mission, qui est de promouvoir Une meilleure santé pour tousMC, nous nous engageons à exercer un impact significatif.',
    caresAward: {
      title: 'Prix Communautaire 2026',
      desc: 'Vous connaissez quelqu’un qui incarne notre raison d’être au travail et dans la communauté? Proposez sa candidature dès aujourd’hui.',
      learn_more: 'En savoir plus >',
    },
    quickLinks: {
      title: 'Liens rapides',
    },
    gallery: {
      title: 'Galerie',
      description:
        'Tout voir',
    },
  },
}
